import { Typography } from 'antd';
import { VerifyEmailForm } from '../components/VerifyEmailForm';
const { Title } = Typography;

export const VerifyEmail = () => {
  return <div>
    <VerifyEmailForm />
  </div>
}